import { ChangeModel } from './update-contact-action-info-models/change-model';

export class UpdateContactActionInfo {
  public Changes: Array<ChangeModel>;

  constructor(init: any) {
    this.Changes = init.Changes;
  }
}
